// constants.js
// export const API_BASE_URL = process.env.REACT_APP_LOCAL_URL;
// export const API_BASE_URL = process.env.REACT_APP_DEV_URL;
export const API_BASE_URL = process.env.REACT_APP_PROD_URL;